import { ChangeEvent, ReactNode, useContext, useEffect, useState } from "react";
import InputSearch from "../../InputSearch";
import { AppContext } from "../../../appContext/AppContext";
import { KEY } from "../../autocompleteOct/models";
import { TableCustom } from "../../table/table-custom/TableCustom";
import { CODE, DEFAULT_PAGE_INDEX, MATERIALS_GROUP, SELECTION_MODE, WAREHOUSE_ID } from "../../../utils/Constant";
import { TablePagination } from "../../table/components/TablePagination";
import { handlePagesChange, handleRowsPerPageChange, rowsForPage } from "../../../utils/PageUtils";
import { columnsDSVatTu } from "../const/Columns";
import { changeStatus, downloadReport, searchVatTu } from "../QuanLyKhoServices";
import { toast } from "react-toastify";
import "../styles.scss"
import { Button, Col, Form, Row } from "react-bootstrap";
import CustomDropdownButtonChoose from "../../CustomDropdownButtonChoose";
import SelectTree from "../../SelectTree";
import { IconMenu } from "../../IconSvg";
import { TreeVatTu } from "../../../phan-he-thong-ke/constants/ColumnsThongKe";
import { getListNhomVatTu } from "../../../phan-he-thong-ke/services/ThongKeServices";
import AdvancedSearch from "../../advanced-search/AdvancedSearch";
import { formatDateFromDTOCustom, formatDateToYYYYMMDD } from "../../../utils/FormatUtils";
import { formatDateToDTOCustom } from "../../../utils/AppFunction";
import { TableCustomHeader } from "../../table/components/TableCustomHeader";
import CustomIconButton from "../../custom-icon-button/CustomIconButton";
import DialogThongTinVatTu from "./DialogThongTinVatTu";
import DialogPreshipment from "./DialogPreshipment";
import {hasAuthority, OBJECT_PERMISSIONS} from "../../../utils/Permission";

interface TableDSVatTuProps {
    warehouseId: number | undefined;
    customTitle?: ReactNode;
    className?: any;
    materialsGroup?: number;
}

const TableDSVatTu: React.FC<TableDSVatTuProps> = (props) => {
    const { warehouseId, customTitle, className, materialsGroup } = props;
    const { setIsLoading } = useContext(AppContext);
    const [dsVatTu, setDsVatTu] = useState([]);
    const [listSelected, setListSelected] = useState<any>();
    const [itemSelected, setItemSelected] = useState<any>();
    const [searchData, setSearchData] = useState<any>({ isNoZero: false });
    const [advancedSearchData, setAdvancedSearchData] = useState<any>({});
    const [rowsPerPage, setRowsPerPage] = useState<number>(20);
    const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
    const [listNhomVatTu, setListNhomVatTu] = useState([]);
    const [nhomVatTu, setNhomVatTu] = useState<any>({});
    const [treeData, setTreeData] = useState<any>(TreeVatTu);
    const [codeCollapses, setCodeCollapses] = useState<string[]>([]);
    const [idSelected, setIdSelected] = useState<string>("");
    const [openDialogAdvancedSearch, setOpenDialogAdvancedSearch] = useState<boolean>(false);
    const [openDialogThemMoi, setOpenDialogThemMoi] = useState<boolean>(false);
    const [openDialogPreshipment, setOpenDialogPreshipment] = useState<boolean>(false);
    const [preshipmentItem, setPreshipmentItem] = useState<any>(null);
    const isSuaTonKho = hasAuthority(OBJECT_PERMISSIONS.SUA_TON_KHO);

    const [configTable, setConfigTable] = useState<any>({
        totalPages: 0,
        totalElements: 0,
        numberOfElements: 0,
    });

    const handleConvertTreeData = (data: any[]) => {
        let convertedData: any[] = data?.map((item, index) => {
            return {
                ...item,
                code: item?.code || item?.name,
                name: item?.name,
                ...(item?.subs &&
                    item?.subs?.length && {
                    filter: handleConvertTreeData(item?.subs || []),
                }),
            };
        });
        return convertedData;
    };

    const handlerClickItem = (item: any) => {
        setNhomVatTu(item);
        setSearchData({ ...searchData, materialType: null });
        let treeDataConverted = {
            code: "all",
            name: "Tất cả dịch vụ",
            icon: <IconMenu />,
            filter: handleConvertTreeData(item?.terms || []),
        };
        setTreeData(treeDataConverted);
    };

    const handleGetSelectedItem = (data: any) => {
        setSearchData({
            ...searchData,
            materialType: data?.code === searchData.materialType ? null : data?.code,
        });
    };

    const handleChangeSearchData = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchData({
            ...searchData,
            [e.target.name]: e.target.value,
        });
    };
    const handlerSearchKeyWorld = () => {
        setPage(DEFAULT_PAGE_INDEX);
        setRowsPerPage(20);
        updatePageData()
    }
    const updatePageData = async () => {
        try {
            setIsLoading(true);
            const { data } = await searchVatTu({
                ...searchData,
                materialGroup: nhomVatTu.id,
                pageIndex: page,
                pageSize: rowsPerPage,
                warehouseId,
                startDate: formatDateFromDTOCustom(advancedSearchData.fromDate),
                endDate: formatDateToDTOCustom(advancedSearchData.toDate),
                reqQuarter: parseInt(advancedSearchData.quarterReq),
                reqMonth: parseInt(advancedSearchData.monthReq),
                biddingYear: parseInt(advancedSearchData.year),
            });
            if (CODE.SUCCESS === data.code) {

                const ListSelected = [...data?.data?.content].filter((item: any) => item?.disable) || [];
                setDsVatTu(data?.data?.content);
                setListSelected(ListSelected)
                setConfigTable({
                    totalPages: Math.ceil(data.data.pageable.totalElements / data.data.pageable.pageSize),
                    totalElements: data?.data?.pageable?.totalElements,
                    // numberOfElements: data?.data?.pageable?.pageNumber,
                })
            } else {
                toast.error('Có lỗi xảy ra, vui lòng thử lại');
            };
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const getListVatTu = async () => {
        try {
            setIsLoading(true);
            let { data } = await getListNhomVatTu();
            let ListData = data?.data?.map((item: any) => {
                return {
                    ...item,
                    name: "Nhóm vật tư - " + item?.name,
                    defauiltName: item?.name,
                }
            })
            setListNhomVatTu(ListData);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getListVatTu();
    }, []);

    useEffect(() => {
        if ((warehouseId || warehouseId === 0) && nhomVatTu?.id) {
            updatePageData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        page, rowsPerPage,
        warehouseId,
        searchData.isNoZero,
        searchData.materialType,
        nhomVatTu?.id,
        advancedSearchData.fromDate,
        advancedSearchData.toDate,
        advancedSearchData.quarterReq,
        advancedSearchData.monthReq,
        advancedSearchData.year,
    ]);

    const handleAdvancedSearch = (values: any) => {
        setAdvancedSearchData(values);
    };

    const handleDownloadReport = async (values?: any) => {
        const data = values || advancedSearchData;
        if (!data.fromDate || !data.toDate) {
            setOpenDialogAdvancedSearch(true);
            return;
        };
        try {
            setIsLoading(true);
            const response = await downloadReport([
                { name: "warehouse_id", value: warehouseId },
                { name: "material_group", value: nhomVatTu?.id },
                { name: "tu_ngay", value: formatDateToYYYYMMDD(data?.fromDate) },
                { name: "den_ngay", value: formatDateToYYYYMMDD(data?.toDate) },
                { name: "req_month", value: parseInt(data.monthReq) || null },
                { name: "bidding_year", value: parseInt(data?.year) || null },
                { name: "req_quarter", value: parseInt(data?.quarterReq) || null },
                { name: "qd_thau", value: data?.serialNumber || null },
            ]);
            const blob = new Blob([response.data], { type: "application/xls" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `excel.xls`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            toast.error('Có lỗi xảy ra, vui lòng thử lại');
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };


    const handlerSelected = (value: any, checked: any) => {
        handlerChangeStatus(value?.inventoryItemId, checked)

    }
    const handlerChangeStatus = async (value?: any, checked?: any) => {
        try {
            const { data } = await changeStatus(value, checked);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const columnsActions = {
        Header: (props: any) => (
            <TableCustomHeader<any>
                tableProps={props}
                title={"Thao tác"}
                className="text-center text-light min-w-100px"
            />
        ),
        id: "actions",
        Cell: ({ ...props }) => {
            const rowData = props.cell.row.original;
            const hasPeShipment = rowData?.peShipment > 0;

            return (
                <div className="d-flex justify-content-center gap-3">
                    {hasPeShipment && (
                        <CustomIconButton
                            variant="edit"
                            tooltip="Xem thuốc bị treo"
                            onClick={() => {
                                setPreshipmentItem({
                                    itemId: rowData?.itemId || rowData?.id,
                                    warehouseId: warehouseId,
                                    serialNumber: rowData?.serialNumber,
                                    consignment: rowData?.consignment,
                                    sellingPrice: rowData?.sellingPrice,
                                    expiryDate: rowData?.expiryDate,
                                    salePrice: rowData?.salePrice,
                                    bhytPrice: rowData?.bhytPrice,
                                    hospitalPrice: rowData?.hospitalPrice,
                                    servicePrice: rowData?.servicePrice,
                                });
                                setOpenDialogPreshipment(true);
                            }}
                        >
                            <i className="bi bi-eye text-navy"></i>
                        </CustomIconButton>
                    )}
                    <CustomIconButton
                        variant="edit"
                        onClick={() => {
                            setItemSelected(rowData);
                            setOpenDialogThemMoi(true);
                        }}
                    >
                        <i className="bi bi-pencil-square text-navy"></i>
                    </CustomIconButton>
                </div>
            );
        },
    };

    const handleCloseDialog = () => {
        setOpenDialogThemMoi(false);
         updatePageData();
    }
    return (
        <Row>
            <Col xl={2} xs={3}>
                <div className="spaces mr-5 bg-white h-calc-vh-130 radius-2">
                    <div className="spaces px-10 pt-4 h-40">
                        <CustomDropdownButtonChoose
                            drop="down"
                            listMenuItems={listNhomVatTu}
                            onClickItem={handlerClickItem}
                            label="Chọn nhóm vật tư"
                            className="spaces w-100 ml-1"
                            menuItemsClassName="w-100 mx-6"
                            defaultValue={materialsGroup}
                        />
                    </div>
                    <SelectTree
                        className="w-100 h-100 border px-0 border-0 overflow-auto"
                        codeCollapses={codeCollapses}
                        handleChangeCollapsesCode={setCodeCollapses}
                        idSelected={idSelected}
                        handleChangeSelectId={setIdSelected}
                        getSelectedItem={handleGetSelectedItem}
                        selectTree={treeData}
                    />
                </div>
            </Col>
            <Col xl={10} xs={9}>
                <div className="bg-white h-100">
                    <div className="flex-1 flex flex-column">
                        <div className="d-flex bg-gray ">
                            <div className="spaces width-100 bg-gray radius-2">
                                <div className="flex justify-content-between bg-white spaces width-100 pr-8" >
                                    <h4 className="text-title text-pri fw-bold fs-4 spaces mb-0 px-10 flex gap-6">
                                        {customTitle ? customTitle : `Danh sách ${nhomVatTu?.defauiltName || ''}`}
                                    </h4>
                                    {warehouseId === WAREHOUSE_ID.KHO_VPP && (
                                        <div className="flex spaces">
                                            <div className="spaces ml-4">
                                                <Button
                                                    className="btn btn-fill mt-4"
                                                    onClick={() => handleDownloadReport()}
                                                >
                                                    Tải báo cáo
                                                </Button>
                                            </div>
                                            <div className="spaces ml-4">
                                                <Button
                                                    className="btn btn-fill mt-4 ml-4"
                                                    onClick={() => setOpenDialogAdvancedSearch(true)}
                                                >
                                                    Tìm kiếm nâng cao
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="d-flex  mt-1 flex-column spaces width-100">
                                    <div className="bg-white">
                                        <div className="d-flex spaces px-8 mt-6 bg-white justify-content-between align-items-center mb-6">
                                            <Form.Check
                                                label="Ẩn thuốc/vật tư có tồn = 0"
                                                className="spaces mr-20"
                                                onChange={(e) => setSearchData({ ...searchData, isNoZero: e.target.checked })}
                                                checked={searchData.isNoZero}
                                            />
                                            <div className="flex-grow-1 ">
                                                <InputSearch
                                                    name="keyword"
                                                    value={searchData?.keyword || ''}
                                                    placeholder="Tìm kiếm theo mã hoặc tên thuốc/vật tư"
                                                    handleChange={handleChangeSearchData}
                                                    handleSearch={() => handlerSearchKeyWorld()}
                                                    handleKeyDown={(e: React.KeyboardEvent) => e.key === KEY.ENTER && handlerSearchKeyWorld()}
                                                    className="spaces h-31 pr-4  radius-3"
                                                />

                                            </div>
                                        </div>
                                        <div className=" spaces bg-white mb-0">
                                            <TableCustom<any>
                                                className={`spaces ${className ? className : "h-bang-ds-vat-tu-ton-kho"}`}
                                                data={dsVatTu}
                                                columns={columnsDSVatTu}
                                                verticalScroll={true}
                                                columnsActions={isSuaTonKho && columnsActions}
                                                selectionMode={SELECTION_MODE.MULTI}
                                                rowSelected={listSelected}
                                                onCheckboxChange={(value: any, checked: any) => { handlerSelected(value, checked) }}
                                                additionalValidateRowSelected={(itemInList: any, row: any) => itemInList?.consignment === row?.consignment}
                                            />
                                            <TablePagination
                                                handlePagesChange={handlePagesChange}
                                                handleRowsPerPageChange={handleRowsPerPageChange}
                                                rowsPerPage={rowsPerPage}
                                                rowsForPage={rowsForPage}
                                                page={page}
                                                setPage={setPage}
                                                setRowsPerPage={setRowsPerPage}
                                                totalPages={Number(configTable.totalPages)}
                                                totalElements={configTable.totalElements}
                                                numberOfElements={configTable.numberOfElements}
                                                className="border border-0"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
            {openDialogAdvancedSearch && warehouseId === WAREHOUSE_ID.KHO_VPP && (
                <AdvancedSearch
                    show={openDialogAdvancedSearch}
                    onHide={() => setOpenDialogAdvancedSearch(false)}
                    initialValues={advancedSearchData}
                    idForm="timKiemNangCaoTonKho"
                    handleSearch={handleAdvancedSearch}
                    downloadReport
                    handleDownloadReport={handleDownloadReport}
                />
            )}
            {openDialogThemMoi &&
                <DialogThongTinVatTu
                    show={openDialogThemMoi}
                    onHide={handleCloseDialog}
                    initialValues={{
                        "suavattu": {
                            ...itemSelected,
                            medicinePicture: [{ src: itemSelected?.medicinePicture }]
                            // whReceive: itemSelected?.whReceive,
                            // createdDate: itemSelected?.createdDate || new Date(),
                            // notes: itemSelected?.notes,
                            // code: null
                        }
                    }}
                    warehouseId={warehouseId}
                    modelId={"suavattu"}
                />
            }
            {openDialogPreshipment &&
                <DialogPreshipment
                    show={openDialogPreshipment}
                    onHide={() => setOpenDialogPreshipment(false)}
                    itemData={preshipmentItem}
                />
            }
        </Row>
    );
};

export default TableDSVatTu;